<style scoped lang="scss" type="text/scss">
    @media screen and (min-width: 95rem) {
        .accommodation-item {
            width: calc(33.3% - 1rem) !important;
        }
    }

    .accommodation-item {
        background-color: #F4F4F4;
        box-sizing: border-box;
        padding: .5rem 1rem;
        display: flex;
        width: calc(50% - 1rem);
        height: 8rem;

        .left-panel {
            width: 5rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            color: #999;
            position: relative;
            box-sizing: border-box;
            padding-bottom: .3rem;

            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: 20%;
                height: 60%;
                width: 1px;
                background-color: #DDD;
            }

            .icon-container {
                flex: 1;
                font-size: 2.7rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .text {
                height: 1.5rem;
                line-height: 0;
                text-align: center;
            }
        }

        .right-panel {
            flex: 1;
            box-sizing: border-box;
            padding: .8rem 0 1rem 1rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;

            .text-panel {
                display: flex;
                align-items: center;

                &.name {
                    color: #666;
                    font-size: 1.5rem;
                }

                &.mobile {
                    margin-top: .3rem;
                    font-size: .85rem;
                    color: #999;
                }
            }

            .address-panel {
                font-size: .85rem;
                margin-top: .3rem;
                color: #999;
            }
        }
    }
</style>

<template>
    <functional-card class="accommodation-item" :operable="editable"
                     @call-edit="callEdit" @call-remove="callRemove">
        <div class="left-panel">
            <div class="icon-container">
                <i class="icon">&#xe617;</i>
            </div>
            <span class="text">#{{ index }}</span>
        </div>
        <div class="right-panel">
            <div class="text-panel name">
                <span class="global-text-ellipsis">{{ info.name }}</span>
            </div>
            <div class="text-panel mobile">
                <span class="global-text-ellipsis">{{ info.mobile }}</span>
            </div>
            <div class="address-panel global-text-ellipsis">
                {{ info.address.full_name }}
            </div>
        </div>
    </functional-card>
</template>

<script>
    import FunctionalCard from '../../../components/functional-card/index';

    export default {
        name: '',
        components: {
            FunctionalCard
        },
        props: {
            index: {
                type: Number | String,
                default: 0
            },
            editable: {
                type: Boolean,
                default: false
            },
            info: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        methods: {
            callEdit (callback) {
                this.$emit('call-edit', callback);
            },
            callRemove (callback) {
                this.$emit('call-remove', callback);
            }
        }
    };
</script>
